// CI = CreateInterview
export const CI_InitialStateAction = (type, data) => {
        return {type, payload: data};
}